import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7084/Activities";
	}
	assignTaskGroupToUser(e, t) {
		let r = this.baseUrl + "/AssignTaskGroupToUser", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processAssignTaskGroupToUser(e)));
	}
	processAssignTaskGroupToUser(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 409 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	assignTaskToUser(e, t) {
		let r = this.baseUrl + "/AssignTaskToUser", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processAssignTaskToUser(e)));
	}
	processAssignTaskToUser(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 409 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	ensureContractInformationTasks(e, t) {
		let r = this.baseUrl + "/EnsureContractInformationTasks", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processEnsureContractInformationTasks(e)));
	}
	processEnsureContractInformationTasks(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 404 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 409 ? J("Payload of ContractInformationTaskSyncError", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutopilotTasksForCampaign(e, t, r) {
		let i = this.baseUrl + "/GetAutopilotTasksForCampaign";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (i += "campaignId=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'contractId' cannot be null.");
		t !== void 0 && (i += "contractId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetAutopilotTasksForCampaign(e)));
	}
	processGetAutopilotTasksForCampaign(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCampaignActivityLogs(e, t) {
		let r = this.baseUrl + "/GetCampaignActivityLogs";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCampaignActivityLogs(e)));
	}
	processGetCampaignActivityLogs(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getDashboardStats(e, t, r) {
		let i = this.baseUrl + "/GetDashboardStats";
		if (i += "?", e === null) throw new globalThis.Error("The parameter 'agencyIds' cannot be null.");
		if (e !== void 0) for (let t of e) i += "agencyIds=" + encodeURIComponent(f(t)) + "&";
		if (t === null) throw new globalThis.Error("The parameter 'assignedToUserIds' cannot be null.");
		if (t !== void 0) for (let e of t) i += "assignedToUserIds=" + encodeURIComponent(f(e)) + "&";
		i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetDashboardStats(e)));
	}
	processGetDashboardStats(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	getTaskProgressorCampaignDetails(e, t) {
		let r = this.baseUrl + "/GetTaskProgressorCampaignDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetTaskProgressorCampaignDetails(e)));
	}
	processGetTaskProgressorCampaignDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 || e.status === 404 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	previewContractInformationTaskConflicts(e, t) {
		let r = this.baseUrl + "/PreviewContractInformationTaskConflicts", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processPreviewContractInformationTaskConflicts(e)));
	}
	processPreviewContractInformationTaskConflicts(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 404 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	progressTasksWithTaskProgressor(e, t) {
		let r = this.baseUrl + "/ProgressTasksWithTaskProgressor", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processProgressTasksWithTaskProgressor(e)));
	}
	processProgressTasksWithTaskProgressor(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 409 || e.status === 500 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	reconcileSettlementTask(e, t) {
		let r = this.baseUrl + "/ReconcileSettlementTask", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processReconcileSettlementTask(e)));
	}
	processReconcileSettlementTask(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? J("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	searchAllTasks(e, t) {
		let r = this.baseUrl + "/SearchAllTasks", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSearchAllTasks(e)));
	}
	processSearchAllTasks(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	toggleTaskSteps(e, t) {
		let r = this.baseUrl + "/ToggleTaskSteps", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processToggleTaskSteps(e)));
	}
	processToggleTaskSteps(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 409 ? J("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
	withdrawWorkflow(e, t) {
		let r = this.baseUrl + "/WithdrawWorkflow", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processWithdrawWorkflow(e)));
	}
	processWithdrawWorkflow(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? J("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : J("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Listings = "Listings", e.Launch = "Launch", e.Contracts = "Contracts", e.Transactions = "Transactions", e.AdminManager = "AdminManager", e.Finance = "Finance", e.ClientServicesOperations = "ClientServicesOperations", e.Onboarding = "Onboarding", e.Executive = "Executive", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.DueDateChange = "DueDateChange", e.Removal = "Removal", e.DependencyChange = "DependencyChange", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.PreLaunch = "PreLaunch", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.WithdrawnPayments = "WithdrawnPayments", e.WithdrawnPaymentsReview = "WithdrawnPaymentsReview", e.NswWithdrawnPayments = "NswWithdrawnPayments", e.TenancyPreparationAgencyManaged = "TenancyPreparationAgencyManaged", e.TenancyPreparationSelfManaged = "TenancyPreparationSelfManaged", e.TenancyInformation = "TenancyInformation", e.SellerDisclosureAgentPreparation = "SellerDisclosureAgentPreparation", e.SellerDisclosureUpload = "SellerDisclosureUpload", e.OwnerBuilderPreparation = "OwnerBuilderPreparation", e.OwnerBuilderDeclarationUpload = "OwnerBuilderDeclarationUpload", e.HolidayRental = "HolidayRental", e.DateOfLastRentIncrease = "DateOfLastRentIncrease", e.DeceasedEstateJointTenants = "DeceasedEstateJointTenants", e.DeceasedEstateTenantsInCommon = "DeceasedEstateTenantsInCommon", e.DeceasedEstateSoleOwner = "DeceasedEstateSoleOwner", e.VendorBankDetailsWithdrawn = "VendorBankDetailsWithdrawn", e.VpaSpreadsheet = "VpaSpreadsheet", e.CampaignVendorSolicitorOutstanding = "CampaignVendorSolicitorOutstanding", e.ContractCompliance = "ContractCompliance", e.ContractPreparation = "ContractPreparation", e.ContractReview = "ContractReview", e.SolicitorExchangeInformation = "SolicitorExchangeInformation", e.SolicitorExchangeContractDates = "SolicitorExchangeContractDates", e.AgentExchangeInformation = "AgentExchangeInformation", e.AgentExchangeContractDates = "AgentExchangeContractDates", e.ContractExchangeInformation = "ContractExchangeInformation", e.ContractExchangeContractDates = "ContractExchangeContractDates", e.NewContract = "NewContract", e.CoolingOffPeriod = "CoolingOffPeriod", e.FinanceDue = "FinanceDue", e.BuildingAndPestDue = "BuildingAndPestDue", e.BodyCorporateDue = "BodyCorporateDue", e.SpecialCondition = "SpecialCondition", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.SettlementPayments = "SettlementPayments", e.SettlementPaymentsReview = "SettlementPaymentsReview", e.Termination = "Termination", e.TerminationPayments = "TerminationPayments", e.TerminationPaymentsReview = "TerminationPaymentsReview", e.NswSettlementPayments = "NswSettlementPayments", e.NswTerminationPayments = "NswTerminationPayments", e.FinaliseMarketingVpa = "FinaliseMarketingVpa", e.FinalisedMarketingPayments = "FinalisedMarketingPayments", e.FinalisedMarketingPaymentReview = "FinalisedMarketingPaymentReview", e.NswFinalisedMarketingPaymentReview = "NswFinalisedMarketingPaymentReview", e.NswFinalisedMarketingPayments = "NswFinalisedMarketingPayments", e.TerminationCoolingOff = "TerminationCoolingOff", e.WithdrawnOffer = "WithdrawnOffer", e.WithdrawnOfferPayments = "WithdrawnOfferPayments", e.WithdrawnOfferPaymentReview = "WithdrawnOfferPaymentReview", e.NswWithdrawnOfferPayment = "NswWithdrawnOfferPayment", e.InitialDeposit = "InitialDeposit", e.BalanceDeposit = "BalanceDeposit", e.EarlyReleaseOfDeposit = "EarlyReleaseOfDeposit", e.DepositExceeds10Percent = "DepositExceeds10Percent", e.VendorBankDetailsSettlement = "VendorBankDetailsSettlement", e.VendorBankDetailsTermination = "VendorBankDetailsTermination", e.BuyerBankDetailsTermination = "BuyerBankDetailsTermination", e.CommissionShortfall = "CommissionShortfall", e.VendorChoiceCommission = "VendorChoiceCommission", e.ReferralAgentConjunctionInvoice = "ReferralAgentConjunctionInvoice", e.CreateBuyerContactInCrm = "CreateBuyerContactInCrm", e.DepositExceeds10PercentPaymentReview = "DepositExceeds10PercentPaymentReview", e.ContractVendorSolicitorOutstanding = "ContractVendorSolicitorOutstanding", e.ContractBuyerSolicitorOutstanding = "ContractBuyerSolicitorOutstanding", e.EarlyReleaseOfDepositPaymentReview = "EarlyReleaseOfDepositPaymentReview", e.NswEarlyReleaseOfDepositPayments = "NswEarlyReleaseOfDepositPayments", e.BuyerBankDetailsWithdrawnOffer = "BuyerBankDetailsWithdrawnOffer", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.CanonicalPrerequisiteMissing = "CanonicalPrerequisiteMissing", e.RepairDidNotConverge = "RepairDidNotConverge", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.MissingTask = "MissingTask", e.UnexpectedTask = "UnexpectedTask", e.DueDateMismatch = "DueDateMismatch", e.DependencyMismatch = "DependencyMismatch", e.DisplayTitleMismatch = "DisplayTitleMismatch", e.WorkflowPlacementMismatch = "WorkflowPlacementMismatch", e.MissingContractDate = "MissingContractDate", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.PreLaunch = "PreLaunch", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.WithdrawnPayments = "WithdrawnPayments", e.WithdrawnPaymentsReview = "WithdrawnPaymentsReview", e.NswWithdrawnPayments = "NswWithdrawnPayments", e.TenancyPreparationAgencyManaged = "TenancyPreparationAgencyManaged", e.TenancyPreparationSelfManaged = "TenancyPreparationSelfManaged", e.TenancyInformation = "TenancyInformation", e.SellerDisclosureAgentPreparation = "SellerDisclosureAgentPreparation", e.SellerDisclosureUpload = "SellerDisclosureUpload", e.OwnerBuilderPreparation = "OwnerBuilderPreparation", e.OwnerBuilderDeclarationUpload = "OwnerBuilderDeclarationUpload", e.HolidayRental = "HolidayRental", e.DateOfLastRentIncrease = "DateOfLastRentIncrease", e.DeceasedEstateJointTenants = "DeceasedEstateJointTenants", e.DeceasedEstateTenantsInCommon = "DeceasedEstateTenantsInCommon", e.DeceasedEstateSoleOwner = "DeceasedEstateSoleOwner", e.VendorBankDetailsWithdrawn = "VendorBankDetailsWithdrawn", e.VpaSpreadsheet = "VpaSpreadsheet", e.CampaignVendorSolicitorOutstanding = "CampaignVendorSolicitorOutstanding", e.ContractCompliance = "ContractCompliance", e.ContractPreparation = "ContractPreparation", e.ContractReview = "ContractReview", e.SolicitorExchangeInformation = "SolicitorExchangeInformation", e.SolicitorExchangeContractDates = "SolicitorExchangeContractDates", e.AgentExchangeInformation = "AgentExchangeInformation", e.AgentExchangeContractDates = "AgentExchangeContractDates", e.ContractExchangeInformation = "ContractExchangeInformation", e.ContractExchangeContractDates = "ContractExchangeContractDates", e.NewContract = "NewContract", e.CoolingOffPeriod = "CoolingOffPeriod", e.FinanceDue = "FinanceDue", e.BuildingAndPestDue = "BuildingAndPestDue", e.BodyCorporateDue = "BodyCorporateDue", e.SpecialCondition = "SpecialCondition", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.SettlementPayments = "SettlementPayments", e.SettlementPaymentsReview = "SettlementPaymentsReview", e.Termination = "Termination", e.TerminationPayments = "TerminationPayments", e.TerminationPaymentsReview = "TerminationPaymentsReview", e.NswSettlementPayments = "NswSettlementPayments", e.NswTerminationPayments = "NswTerminationPayments", e.FinaliseMarketingVpa = "FinaliseMarketingVpa", e.FinalisedMarketingPayments = "FinalisedMarketingPayments", e.FinalisedMarketingPaymentReview = "FinalisedMarketingPaymentReview", e.NswFinalisedMarketingPaymentReview = "NswFinalisedMarketingPaymentReview", e.NswFinalisedMarketingPayments = "NswFinalisedMarketingPayments", e.TerminationCoolingOff = "TerminationCoolingOff", e.WithdrawnOffer = "WithdrawnOffer", e.WithdrawnOfferPayments = "WithdrawnOfferPayments", e.WithdrawnOfferPaymentReview = "WithdrawnOfferPaymentReview", e.NswWithdrawnOfferPayment = "NswWithdrawnOfferPayment", e.InitialDeposit = "InitialDeposit", e.BalanceDeposit = "BalanceDeposit", e.EarlyReleaseOfDeposit = "EarlyReleaseOfDeposit", e.DepositExceeds10Percent = "DepositExceeds10Percent", e.VendorBankDetailsSettlement = "VendorBankDetailsSettlement", e.VendorBankDetailsTermination = "VendorBankDetailsTermination", e.BuyerBankDetailsTermination = "BuyerBankDetailsTermination", e.CommissionShortfall = "CommissionShortfall", e.VendorChoiceCommission = "VendorChoiceCommission", e.ReferralAgentConjunctionInvoice = "ReferralAgentConjunctionInvoice", e.CreateBuyerContactInCrm = "CreateBuyerContactInCrm", e.DepositExceeds10PercentPaymentReview = "DepositExceeds10PercentPaymentReview", e.ContractVendorSolicitorOutstanding = "ContractVendorSolicitorOutstanding", e.ContractBuyerSolicitorOutstanding = "ContractBuyerSolicitorOutstanding", e.EarlyReleaseOfDepositPaymentReview = "EarlyReleaseOfDepositPaymentReview", e.NswEarlyReleaseOfDepositPayments = "NswEarlyReleaseOfDepositPayments", e.BuyerBankDetailsWithdrawnOffer = "BuyerBankDetailsWithdrawnOffer", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.FiveDays = "FiveDays", e.TenDays = "TenDays", e.NDays = "NDays", e.NoCoolingOff = "NoCoolingOff", e;
}({}), ne = /* @__PURE__ */ function(e) {
	return e.Waived = "Waived", e.Exempt = "Exempt", e;
}({}), re = /* @__PURE__ */ function(e) {
	return e.OnDate = "OnDate", e.NdaysFromDate = "NdaysFromDate", e.OnSpecificDate = "OnSpecificDate", e.UponSatisfactionOfSpecialCondition = "UponSatisfactionOfSpecialCondition", e.AdditionalReason = "AdditionalReason", e.NotApplicable = "NotApplicable", e.NotSubjectToFinance = "NotSubjectToFinance", e.Other = "Other", e.AsPerContract = "AsPerContract", e.BuildingAndPestBeingSatisfied = "BuildingAndPestBeingSatisfied", e.FinanceBeingSatisfied = "FinanceBeingSatisfied", e.OnCoolingOffDate = "OnCoolingOffDate", e;
}({}), ie = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Finance = "Finance", e;
}({}), ae = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.BusinessDays = "BusinessDays", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.Weeks = "Weeks", e.Months = "Months", e.Years = "Years", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.On = "On", e.NDaysFrom = "NDaysFrom", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Initial = "Initial", e.Balance = "Balance", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Dollar = "Dollar", e.Percentage = "Percentage", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.DatesAndConditions = "DatesAndConditions", e.SpecialConditions = "SpecialConditions", e.Deposits = "Deposits", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.NotApplicable = "NotApplicable", e.AlreadySynchronized = "AlreadySynchronized", e.Repaired = "Repaired", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.OnDate = "OnDate", e.NdaysFromDate = "NdaysFromDate", e.OnSpecificDate = "OnSpecificDate", e.UponSatisfactionOfSpecialCondition = "UponSatisfactionOfSpecialCondition", e.AdditionalReason = "AdditionalReason", e.NotApplicable = "NotApplicable", e.NotSubjectToFinance = "NotSubjectToFinance", e.Other = "Other", e.AsPerContract = "AsPerContract", e.BuildingAndPestBeingSatisfied = "BuildingAndPestBeingSatisfied", e.FinanceBeingSatisfied = "FinanceBeingSatisfied", e.OnCoolingOffDate = "OnCoolingOffDate", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Contract = "Contract", e.Unconditional = "Unconditional", e.Finance = "Finance", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.BusinessDays = "BusinessDays", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Days = "Days", e.Weeks = "Weeks", e.Months = "Months", e.Years = "Years", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.Added = "Added", e.Created = "Created", e.Generated = "Generated", e.Obtained = "Obtained", e.Updated = "Updated", e.Completed = "Completed", e.Converted = "Converted", e.Uploaded = "Uploaded", e.SentEmail = "SentEmail", e.SentViaDocuSign = "SentViaDocuSign", e.FailedToSend = "FailedToSend", e.Archived = "Archived", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.DatesAndConditions = "DatesAndConditions", e.SpecialConditions = "SpecialConditions", e.Deposits = "Deposits", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.Today = "Today", e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e.Overdue = "Overdue", e.TodayOrOverdue = "TodayOrOverdue", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Custom = "Custom", e.SellerToInstallSmokeAlarms = "SellerToInstallSmokeAlarms", e.SellerToObtainPoolSafetyCertificate = "SellerToObtainPoolSafetyCertificate", e.NoticeOfNoFunctioningBodyCorporate = "NoticeOfNoFunctioningBodyCorporate", e.SubjectToBodyCorporateApprovalOfPet = "SubjectToBodyCorporateApprovalOfPet", e.DueDiligence = "DueDiligence", e.RegistrationOfRecordOfDeath = "RegistrationOfRecordOfDeath", e.SubjectToSaleUnconditionalAndSettlement = "SubjectToSaleUnconditionalAndSettlement", e.SubjectToUnconditionalAndSettlement = "SubjectToUnconditionalAndSettlement", e.SubjectToSettlement = "SubjectToSettlement", e.SunsetClause = "SunsetClause", e.TransmissionByDeath = "TransmissionByDeath", e.TerminationOfPriorContract = "TerminationOfPriorContract", e.EarlyReleaseOfDepositToSeller = "EarlyReleaseOfDepositToSeller", e.PropertyAtSellersRiskUntilSettlement = "PropertyAtSellersRiskUntilSettlement", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.WithdrawnOffer = "WithdrawnOffer", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.ApprovalReceivedNotConfirmed = "ApprovalReceivedNotConfirmed", e.BalanceDepositTask = "BalanceDepositTask", e.InitialDepositTask = "InitialDepositTask", e.ContractUploadedStatusDraft = "ContractUploadedStatusDraft", e.ContractDateNotSet = "ContractDateNotSet", e.CommissionShortfallConfirmation = "CommissionShortfallConfirmation", e.CommissionPlanTypeVendorChoice = "CommissionPlanTypeVendorChoice", e.LaunchDateNotSet = "LaunchDateNotSet", e.MarkedAsExchanged = "MarkedAsExchanged", e.TerminationTaskBuyerBankDetails = "TerminationTaskBuyerBankDetails", e.TerminationTaskVendorBankDetails = "TerminationTaskVendorBankDetails", e.WithdrawnTaskVendorBankDetails = "WithdrawnTaskVendorBankDetails", e.VendorBankDetailsOutstanding = "VendorBankDetailsOutstanding", e.NotMarkedAsSettled = "NotMarkedAsSettled", e.ReferralInvoiceOutstanding = "ReferralInvoiceOutstanding", e.WithdrawnOfferBuyerBankDetails = "WithdrawnOfferBuyerBankDetails", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.WithdrawnOffer = "WithdrawnOffer", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.PreLaunch = "PreLaunch", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.WithdrawnPayments = "WithdrawnPayments", e.WithdrawnPaymentsReview = "WithdrawnPaymentsReview", e.NswWithdrawnPayments = "NswWithdrawnPayments", e.TenancyPreparationAgencyManaged = "TenancyPreparationAgencyManaged", e.TenancyPreparationSelfManaged = "TenancyPreparationSelfManaged", e.TenancyInformation = "TenancyInformation", e.SellerDisclosureAgentPreparation = "SellerDisclosureAgentPreparation", e.SellerDisclosureUpload = "SellerDisclosureUpload", e.OwnerBuilderPreparation = "OwnerBuilderPreparation", e.OwnerBuilderDeclarationUpload = "OwnerBuilderDeclarationUpload", e.HolidayRental = "HolidayRental", e.DateOfLastRentIncrease = "DateOfLastRentIncrease", e.DeceasedEstateJointTenants = "DeceasedEstateJointTenants", e.DeceasedEstateTenantsInCommon = "DeceasedEstateTenantsInCommon", e.DeceasedEstateSoleOwner = "DeceasedEstateSoleOwner", e.VendorBankDetailsWithdrawn = "VendorBankDetailsWithdrawn", e.VpaSpreadsheet = "VpaSpreadsheet", e.CampaignVendorSolicitorOutstanding = "CampaignVendorSolicitorOutstanding", e.ContractCompliance = "ContractCompliance", e.ContractPreparation = "ContractPreparation", e.ContractReview = "ContractReview", e.SolicitorExchangeInformation = "SolicitorExchangeInformation", e.SolicitorExchangeContractDates = "SolicitorExchangeContractDates", e.AgentExchangeInformation = "AgentExchangeInformation", e.AgentExchangeContractDates = "AgentExchangeContractDates", e.ContractExchangeInformation = "ContractExchangeInformation", e.ContractExchangeContractDates = "ContractExchangeContractDates", e.NewContract = "NewContract", e.CoolingOffPeriod = "CoolingOffPeriod", e.FinanceDue = "FinanceDue", e.BuildingAndPestDue = "BuildingAndPestDue", e.BodyCorporateDue = "BodyCorporateDue", e.SpecialCondition = "SpecialCondition", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.SettlementPayments = "SettlementPayments", e.SettlementPaymentsReview = "SettlementPaymentsReview", e.Termination = "Termination", e.TerminationPayments = "TerminationPayments", e.TerminationPaymentsReview = "TerminationPaymentsReview", e.NswSettlementPayments = "NswSettlementPayments", e.NswTerminationPayments = "NswTerminationPayments", e.FinaliseMarketingVpa = "FinaliseMarketingVpa", e.FinalisedMarketingPayments = "FinalisedMarketingPayments", e.FinalisedMarketingPaymentReview = "FinalisedMarketingPaymentReview", e.NswFinalisedMarketingPaymentReview = "NswFinalisedMarketingPaymentReview", e.NswFinalisedMarketingPayments = "NswFinalisedMarketingPayments", e.TerminationCoolingOff = "TerminationCoolingOff", e.WithdrawnOffer = "WithdrawnOffer", e.WithdrawnOfferPayments = "WithdrawnOfferPayments", e.WithdrawnOfferPaymentReview = "WithdrawnOfferPaymentReview", e.NswWithdrawnOfferPayment = "NswWithdrawnOfferPayment", e.InitialDeposit = "InitialDeposit", e.BalanceDeposit = "BalanceDeposit", e.EarlyReleaseOfDeposit = "EarlyReleaseOfDeposit", e.DepositExceeds10Percent = "DepositExceeds10Percent", e.VendorBankDetailsSettlement = "VendorBankDetailsSettlement", e.VendorBankDetailsTermination = "VendorBankDetailsTermination", e.BuyerBankDetailsTermination = "BuyerBankDetailsTermination", e.CommissionShortfall = "CommissionShortfall", e.VendorChoiceCommission = "VendorChoiceCommission", e.ReferralAgentConjunctionInvoice = "ReferralAgentConjunctionInvoice", e.CreateBuyerContactInCrm = "CreateBuyerContactInCrm", e.DepositExceeds10PercentPaymentReview = "DepositExceeds10PercentPaymentReview", e.ContractVendorSolicitorOutstanding = "ContractVendorSolicitorOutstanding", e.ContractBuyerSolicitorOutstanding = "ContractBuyerSolicitorOutstanding", e.EarlyReleaseOfDepositPaymentReview = "EarlyReleaseOfDepositPaymentReview", e.NswEarlyReleaseOfDepositPayments = "NswEarlyReleaseOfDepositPayments", e.BuyerBankDetailsWithdrawnOffer = "BuyerBankDetailsWithdrawnOffer", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.IndependentCampaign = "IndependentCampaign", e.Contract = "Contract", e.IndependentContract = "IndependentContract", e.Deposit = "Deposit", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.ChangeStage = "ChangeStage", e.ReinitialiseTasksOnly = "ReinitialiseTasksOnly", e;
}({}), H = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.WithdrawnOffer = "WithdrawnOffer", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), oe = /* @__PURE__ */ function(e) {
	return e.ChangeStage = "ChangeStage", e.ReinitialiseTasksOnly = "ReinitialiseTasksOnly", e;
}({}), U = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.WithdrawnOffer = "WithdrawnOffer", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), W = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.WithdrawnOffer = "WithdrawnOffer", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), G = /* @__PURE__ */ function(e) {
	return e.Listings = "Listings", e.Launch = "Launch", e.Contracts = "Contracts", e.Transactions = "Transactions", e.AdminManager = "AdminManager", e.Finance = "Finance", e.ClientServicesOperations = "ClientServicesOperations", e.Onboarding = "Onboarding", e.Executive = "Executive", e;
}({}), K = /* @__PURE__ */ function(e) {
	return e.IncludeShorteningOfCoolingOff = "IncludeShorteningOfCoolingOff", e.IncludeWaiverOfCoolingOff = "IncludeWaiverOfCoolingOff", e;
}({}), q = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isActivitiesApiException = !0;
	static isActivitiesApiException(e) {
		return e.isActivitiesApiException === !0;
	}
};
function J(e, t, n, r, i) {
	throw i ?? new q(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var Y = "activities";
function se(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var X = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), se(r);
}, ce = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[Y] || `${e}/${Y}`;
}, Z = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = ce(i), u = c, d = X(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = X(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, Q = a({}), le = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = Z(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(Q.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, ue = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.assignTaskGroupToUser(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		assignTaskGroupToUser: u,
		assignTaskGroupToUserPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, de = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.assignTaskToUser(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		assignTaskToUser: u,
		assignTaskToUserPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, fe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.ensureContractInformationTasks(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		ensureContractInformationTasks: u,
		ensureContractInformationTasksPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, pe = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getAutopilotTasksForCampaign",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getAutopilotTasksForCampaign(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getAutopilotTasksForCampaign",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, he = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getCampaignActivityLogs", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaignActivityLogs(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaignActivityLogs", e] });
	}, e[0] = t, e[1] = n), n;
}, _e = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(Q), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getDashboardStats",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getDashboardStats(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getDashboardStats",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ye = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(Q), s;
	n[0] === e ? s = n[1] : (s = ["getTaskProgressorCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getTaskProgressorCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, be = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getTaskProgressorCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, $ = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.previewContractInformationTaskConflicts(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		previewContractInformationTaskConflicts: u,
		previewContractInformationTaskConflictsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, xe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.progressTasksWithTaskProgressor(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		progressTasksWithTaskProgressor: u,
		progressTasksWithTaskProgressorPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Se = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.reconcileSettlementTask(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		reconcileSettlementTask: u,
		reconcileSettlementTaskPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Ce = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.searchAllTasks(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		searchAllTasks: u,
		searchAllTasksPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, we = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.toggleTaskSteps(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		toggleTaskSteps: u,
		toggleTaskStepsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Te = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(Q), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.withdrawWorkflow(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		withdrawWorkflow: u,
		withdrawWorkflowPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { Q as ActivitiesApiContext, q as ActivitiesApiException, le as ActivitiesApiProvider, p as ActivitiesClient, Y as ActivitiesRoute, m as AutopilotTaskDtoTeamType, h as ContractInformationTaskConflictImpact, g as ContractInformationTaskConflictTaskType, _ as ContractInformationTaskSyncErrorReason, v as ContractInformationTaskSyncIssueKind, ee as ContractInformationTaskSyncIssueTaskType, te as CoolingOffDetailsCoolingOffType, ne as CoolingOffDetailsNoCoolingOffReason, re as DepositCondition, ie as DepositConditionType, ae as DepositDayType, y as DepositFromDateTimeUnit, b as DepositPayable, x as DepositType, S as DepositValueType, C as EnsureContractInformationTasksRequestScope, w as EnsureContractInformationTasksResponseOutcome, T as FormConditionCondition, E as FormConditionConditionType, D as FormConditionDayType, O as FormConditionFromDateTimeUnit, k as IActivityLogResponseAction, A as PreviewContractInformationTaskConflictsRequestScope, j as SearchTaskRequestTaskDue, M as SpecialConditionDataConditionType, N as Stages, P as States, F as TaskBlockerBlockerType, I as TaskCategoryStage, L as TaskCategoryState, R as TaskCategoryTaskType, z as TaskCategoryWorkflowType, B as TaskProgressorCampaignDetailsState, V as TaskProgressorRequestMode, H as TaskProgressorRequestTargetStage, oe as TaskProgressorResponseMode, U as TaskProgressorResponseTargetStage, W as TaskProgressorStageOptionStage, G as TeamTypes, K as WaiverOfCoolingOffCoolingOffCondition, Z as useActivitiesClientContext, ue as useAssignTaskGroupToUser, de as useAssignTaskToUser, fe as useEnsureContractInformationTasks, pe as useGetAutopilotTasksForCampaign, he as useGetCampaignActivityLogs, _e as useGetDashboardStats, ye as useGetTaskProgressorCampaignDetails, me as useInvalidateUseGetAutopilotTasksForCampaign, ge as useInvalidateUseGetCampaignActivityLogs, ve as useInvalidateUseGetDashboardStats, be as useInvalidateUseGetTaskProgressorCampaignDetails, $ as usePreviewContractInformationTaskConflicts, xe as useProgressTasksWithTaskProgressor, Se as useReconcileSettlementTask, Ce as useSearchAllTasks, we as useToggleTaskSteps, Te as useWithdrawWorkflow };
